import styled from 'styled-components'

export const IconButtonStyle = styled.button`
  background: transparent;
  pointer-events: ${p => (p.mood === 'disabled' ? 'none' : 'auto')};
  height: ${p => p.height || 50}px;
  width: ${p => (p.width ? p.width : p.height ? p.height : 40)}px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 0;

  span {
    display: flex;
    justify-content: center;
    width: ${p => (p.iconHeight ? p.iconHeight : 20)}px;
    height: ${p => (p.iconHeight ? p.iconHeight : 20)}px;

    svg {
      height: ${p => (p.iconHeight ? p.iconHeight : 20)}px;
      transition: all ${p => p.theme.duration.s} ${p => p.theme.function.oq};
      fill: ${props =>
        props.defaultColor
          ? (props.theme.color[props.defaultColor] || props.defaultColor)
          : props.mood === 'disabled'
          ? props.theme.color.disabled
          : props.theme.color.gray};
      transform: ${props =>
        props.rotate ? `rotate(${props.rotate}deg)` : 'none'};
    }
  }
  &:hover {
    svg {
      fill: ${props => props.hoverColor
        ? (props.theme.color[props.hoverColor] || props.hoverColor)
        : props.theme.color.turquoise};
    }
  }

  &:active {
    svg {
      transform: scale(0.8);
    }
  }
`
